export function PH({ label, dark, style }) {
  return (
    <div className={"ph" + (dark ? " dark" : "")} style={style}>
      <span className="ph-label">{label}</span>
    </div>
  );
}
